import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiLegacyClientsList } from '@/entities/legacy-clients/modules/api/legacy-clients';
import type { ApiLegacyClientsListParams } from '@/shared/types/api/legacy-clients';

export const useLegacyClientsList = (params: ApiLegacyClientsListParams) =>
  useFetch({
    api: () => apiLegacyClientsList(params),
    keywords: queryKeys.legacyClients.list(params),
    staleTime: 60_000,
  });
